<template>
    <div :data-component="$options.name">
        <ms-toast-manager
            class="pointer-events-auto"
            :toasts="modelValue"
            :isLocalToastManager="true"
            @remove="removeId"
            @startTimeout="startTimeout"
            @stopTimeout="stopTimeout"
        />
    </div>
</template>
<script lang="ts" src="./MsLocalToastManager.ts" />
